import { Flex, useTheme } from '@chakra-ui/react';
import { Button } from '@mesh.ai/rabbit';
import { useIsNetchexNewNavAndAdminOrManagerPage } from 'Deer/hooks/useIsNetchexNewNavAndAdminOrManagerPage';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { isMobileView } from 'constants/isMobileView';
import {
  NETCHEX_NEW_ICON_ONLY_SIDEPANEL_WIDTH,
  NETCHEX_SIDEPANEL_WIDTH,
  isNetchexLogin,
} from 'constants/netChexConstants';

import { TextLabel } from 'uiToolkitV1/Typography';

const FooterSection = ({ onSave, onCancel, isSaveDisabled }) => {
  const theme = useTheme();
  const { isNetchexNewSidePanelCollapsed, isNetchexNewSideNav } = useIsNetchexNewNavAndAdminOrManagerPage();

  const getFooterWidth = () => {
    if (checkNewNavEnabled()) {
      if (isNetchexLogin) {
        if (isNetchexNewSideNav) {
          return isNetchexNewSidePanelCollapsed
            ? `calc(100% - ${NETCHEX_NEW_ICON_ONLY_SIDEPANEL_WIDTH})`
            : `calc(100% - ${NETCHEX_SIDEPANEL_WIDTH})`;
        }
        return '100%';
      }
      return '100%';
    }
    if (isMobileView()) {
      return '100%';
    }
    return 'calc(100vw - 250px)';
  };

  return (
    <Flex
      bgColor={theme.colors.surface.F5F7F9}
      alignItems="center"
      justifyContent="space-between"
      width={getFooterWidth()}
      columnGap={4}
      sx={{
        position: isNetchexLogin ? 'fixed' : null,
        bottom: 0,
        right: 0,
        padding: isNetchexLogin ? '16px' : null,
      }}
    >
      <Flex flexDir="column" width="100%">
        {isNetchexLogin && (
          <TextLabel bold py="12px">
            Note: Changes made here will apply across all companies in the organization.
          </TextLabel>
        )}
        <Flex alignItems="center" justifyContent="space-between" width="100%">
          <Button onClick={() => onCancel(true)} variant="outline" disabled={false}>
            Cancel
          </Button>

          <Button onClick={onSave} disabled={isSaveDisabled}>
            Save
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default FooterSection;
